import * as React from 'react';
import { SVGProps } from 'react';

const IconHandSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.997 4a1 1 0 1 1 2 0v7h1V5a1 1 0 1 1 2 0v6h1V8a1 1 0 1 1 2 0v7.5a5.5 5.5 0 0 1-9.76 3.48L4.44 14.182a1.5 1.5 0 1 1 2.122-2.122l1.436 1.438V6c0-.287.12-.545.314-.727A1 1 0 0 1 9.998 6v5h1V4z" />
  </svg>
);
export default IconHandSizeM;
